import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { UtilsProvider } from '../../providers/myria/utils-provider';

@Component({
  selector: 'rmt-input-search',
  templateUrl: 'rmt-input-search.html'
})
export class RmtInputSearchComponent {
  @ViewChild('inputField') inputField;

  //[isActive]="searchbarInput != ''" 
  //[inputText]="searchbarInput"
  //[(ngModel)]="searchbarInput"
  //(input)="inputSearch()"

  focused = false;
  onClear;
  manualInputEnabled: boolean = false;
  isListScrolling : boolean = false;
  delayBlur = false;
  pendingBlur = false;
  blurTimeout = null;
  @Input() isActive = true;
  @Input() inputText;
  @Input() title;
  @Input() inputId;
  @Input() errorMessage;

  //Inputs for OverlaySearch
  @Input() isOverlaySearch: boolean = false;
  @Input() hideOverlaySearch: boolean = true;
  @Input() displayOverlaySpinner: boolean = false;
  @Input() enabledManualForm: boolean = false;
  @Input() allowManualInput: boolean = false;
  @Input() manualText: string;
  @Input() manualTextCTA: string;
  @Input() onSelectItem;
  @Input() onManualSelectItem;
  @Input() overlaySearchItems;

  @Output() focusEmitter = new EventEmitter<any>();
  @Output() blurEmitter = new EventEmitter<any>();
  @Output() clearEmitter = new EventEmitter<any>();

  constructor(private utilsProvider: UtilsProvider) {
    this.onClear = () => {
      this.clearEmitter.emit();
    }
  }
  ngAfterViewInit() {
    if(document.getElementsByTagName("rmt-loqate") && document.getElementsByTagName("rmt-loqate").length > 0) {
      window.addEventListener('scroll', (event: any) => this.onListScroll(event),true);
    }
  }

  ngOnDestroy() {
    if(document.getElementsByTagName("rmt-loqate") && document.getElementsByTagName("rmt-loqate").length > 0) {
      window.removeEventListener('scroll', (event: any) => this.onListScroll(event));
    }
  }

  getInputField() {
    return this.inputField;
  }

  getBoldName(addressName) {
    let result = addressName;
    if(this.inputField) {
      const field = this.inputField.getNativeElement();
      if (field)
        result = this.utilsProvider.highlightMatchSearchResult(addressName, field);
    }

    return result;

  }

  onManualClick() {
    this.manualInputEnabled = true;
    this.onManualSelectItem();
  }

  pendingClick() {
    this.delayBlur = true;
  }

  finishedClick(ev) {
    if (this.blurTimeout)
      window.clearTimeout(this.blurTimeout);
    if (this.pendingBlur) {
      this.focused = false;
      this.blurEmitter.emit(ev);
      this.delayBlur = false;
      this.pendingBlur = false;
    }
  }

  chooseItem(item) {
    this.onSelectItem(item);
  }

  focus() {
    if (this.blurTimeout)
      window.clearTimeout(this.blurTimeout);
    this.delayBlur = false;
    this.pendingBlur = false;
    this.focused = true;
    this.focusEmitter.emit();
  }

  blur(ev) {
    if (this.blurTimeout)
      window.clearTimeout(this.blurTimeout);
    if(!this.isListScrolling){ // Added this to avoid blur while scrolling the list.
      if (this.delayBlur) {
        this.pendingBlur = true;
        this.blurTimeout = setTimeout(() => { // Adding this timeout as blur is firing before the mousedown event on devices.
          this.focused = false;
          this.blurEmitter.emit(ev);
        }, 500);
      }
      else {
        this.focused = false;
        this.blurEmitter.emit(ev);        
      }
      this.delayBlur = false;
    }
  }

  onListScroll(event){
    if((<HTMLElement>event.target).id === 'addressList'){
      this.isListScrolling = true;
      setTimeout(() => {
        this.isListScrolling = false;
      }, 500);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-input-search/rmt-input-search.ts